import roles from "../helper/roles";

const routes = [
  // {
  //   access_path: "/dashboard/dashboards",
  //   access_name: ["home_page","creator_home"],
  //   access_icon: "icon-diamond",
  //   access_label: "Home"
  // },
  {
    access_path: "/user/notification",
    access_name: "my_profile",
    access_icon: "icon-diamond",
    access_label: "User Notification"
  },
  {
    access_path: "/user/profile",
    access_name: "my_profile",
    access_icon: "icon-diamond",
    access_label: "User Profile"
  },
  {
    access_path: "/system/system-logs",
    access_name: "system_logs",
    access_icon: "icon-diamond",
    access_label: "System Logs"
  },
  {
    access_path: "/system/system-scheduler",
    access_name: "system_scheduler",
    access_icon: "icon-diamond",
    access_label: "System Scheduler"
  },
  {
    access_path: "/creator/onboarding",
    access_name: "creator_onboarding",
    access_icon: "icon-diamond",
    access_label: "Creator onboarding"
  },
  {
    access_path: "/creator/experience-builder",
    access_name: "experience_builder",
    access_icon: "icon-diamond",
    access_label: "Creator Experience Builder"
  },
  {
    access_path: "/creator/dashboard",
    access_name: "creator_dashboard",
    access_icon: "icon-diamond",
    access_label: "Creator Dashboard"
  },
  {
    access_path: "/creator/experience-manager/overview/:session_code",
    access_name: "experience_manager",
    access_icon: "icon-diamond",
    access_label: "OverView Page"
  },
  {
    access_path: "/creator/experience-manager/koverview/:session_code",
    access_name: "experience_manager",
    access_icon: "icon-diamond",
    access_label: "known Overview Page"
  },
  {
    access_path: "/creator/experience-manager/participants/:session_code",
    access_name: "experience_manager",
    access_icon: "icon-diamond",
    access_label: "Participants Page"
  },
  {
    access_path: "/creator/experience-manager/invite/:session_code/",
    access_name: "experience_manager",
    access_icon: "icon-diamond",
    access_label: "Participants Invite Page"
  },
  {
    access_path: "/creator/experience-manager/manage-hubs",
    access_name: "experience_manager",
    access_icon: "icon-diamond",
    access_label: "Hub Manage Page"
  },
  {
    access_path: "/creator/experience-manager/analyze/:session_code",
    access_name: "experience_manager",
    access_icon: "icon-diamond",
    access_label: "Analyze Page"
  },
  {
    access_path: "/creator/experience-manager/compare/:session_code",
    access_name: "experience_manager",
    access_icon: "icon-diamond",
    access_label: "Compare Page"
  },
  {
    access_path: "/participant/lists",
    access_name: "participant_list",
    access_icon: "icon-diamond",
    access_label: "Participant List"
  },
  {
    access_path: "/participant/list/:list_id/detail",
    access_name: "participant_list",
    access_icon: "icon-diamond",
    access_label: "Participant List Detail"
  },
  {
    access_path: "/participant/dashboard",
    access_name: "participant_dashboard",
    access_icon: "icon-diamond",
    access_label: "Participant Dashboard"
  },
  {
    access_path: "/participant/planning/1",
    access_name: "participant_dashboard",
    access_icon: "icon-diamond",
    access_label: "Participant Planning"
  },
  {
    access_path: "/participant/planning/2",
    access_name: "participant_dashboard",
    access_icon: "icon-diamond",
    access_label: "Participant Planning"
  },
  {
    access_path: "/participant/planning/3",
    access_name: "participant_dashboard",
    access_icon: "icon-diamond",
    access_label: "Participant Planning"
  },
  {
    access_path: "/participant/planning/4",
    access_name: "participant_dashboard",
    access_icon: "icon-diamond",
    access_label: "Participant Planning"
  },
  {
    access_path: "/participant/planning/5",
    access_name: "participant_dashboard",
    access_icon: "icon-diamond",
    access_label: "Participant Planning"
  },
  {
    access_path: "/participant/planning/6",
    access_name: "participant_dashboard",
    access_icon: "icon-diamond",
    access_label: "Participant Planning"
  },
  {
    access_path: "/admin/roles",
    access_name: "admin_roles",
    access_icon: "icon-diamond",
    access_label: "Admin roles"
  },
  //{
  //  access_path: "/admin/user",
  //  access_name: "admin_users",
  //  access_icon: "icon-diamond",
  //  access_label: "Admin users"
  //},
  {
    access_path: "/admin/admin-setting",
    access_name: "admin_setting",
    access_icon: "icon-diamond",
    access_label: "Admin setting"
  },
  {
    access_path: "/user/video",
    access_name: "my_profile",
    access_icon: "icon-diamond",
    access_label: "Video"
  },
  // admin user - billing
  {
    access_path: "/admin/user",
    access_name: "admin_users",
    access_icon: "icon-diamond",
    access_label: "Admin Users"
  },
  {
    access_path: "/admin/billing",
    access_name: "admin_users",
    access_icon: "icon-diamond",
    access_label: "Admin Billing"
  },
  // For Trail
  {
    access_path: "/subscriber/user/profile",
    access_name: roles['trial']['profile'],
    access_icon: "icon-diamond",
    access_label: "Trial User Profile"
  },
  {
    access_path: "/subscriber/creator/onboarding",
    access_name: roles['trial']['onboarding'],
    access_icon: "icon-diamond",
    access_label: "Trial Creator onboarding"
  },
  {
    access_path: "/subscriber/creator/dashboard",
    access_name: roles['trial']['dashboard'],
    access_icon: "icon-diamond",
    access_label: "Trial Creator Dashboard"
  },
  {
    access_path: "/subscriber/creator/experience-manager/overview/:session_code",
    access_name: roles['trial']['experiences'],
    access_icon: "icon-diamond",
    access_label: "Trial OverView Page"
  },
  {
    access_path: "/subscriber/creator/experience-manager/koverview/:session_code",
    access_name: roles['trial']['experiences'],
    access_icon: "icon-diamond",
    access_label: "Trial OverView Page"
  },
  {
    access_path: "/subscriber/creator/experience-manager/participants/:session_code",
    access_name: roles['trial']['experiences'],
    access_icon: "icon-diamond",
    access_label: "Trial Participants Page"
  },
  {
    access_path: "/subscriber/creator/experience-manager/invite/:session_code/",
    access_name: roles['trial']['experiences'],
    access_icon: "icon-diamond",
    access_label: "Trial Participants Invite Page"
  },
  {
    access_path: "/subscriber/creator/experience-manager/manage-hubs",
    access_name: roles['trial']['experiences'],
    access_icon: "icon-diamond",
    access_label: "Hub Manage Page"
  },
  {
    access_path: "/subscriber/creator/experience-manager/analyze/:session_code",
    access_name: roles['trial']['experiences'],
    access_icon: "icon-diamond",
    access_label: "Trial Analyze Page"
  },
  {
    access_path: "/subscriber/creator/experience-manager/compare/:session_code",
    access_name: roles['trial']['experiences'],
    access_icon: "icon-diamond",
    access_label: "Trial Compare Page"
  },
  {
    access_path: "/subscriber/creator/experience-builder",
    access_name: roles['trial']['builder'],
    access_icon: "icon-diamond",
    access_label: "Trial Creator Experience Builder"
  },
  //trial admin user - billing
  {
    access_path: "/subscriber/admin/user",
    access_name: roles['trial']['admin'],
    access_icon: "icon-diamond",
    access_label: "Trial Admin User List"
  },
  {
    access_path: "/subscriber/admin/billing",
    access_name: roles['trial']['admin'],
    access_icon: "icon-diamond",
    access_label: "Trial Billing Page"
  },
];

export default routes;
